import React, {createContext} from "react";

export type State = {
  title: string;
  apolloList: Array<{
    accountGroup: {
      id: number;
      name: string;
      roleAuthorization: number;
      customSegment: number;
      geoSegment: number;
    };
    accountList: Array<{
      id: number;
      name: string;
      trackerId: string;
    }>,
  }>,
  current: {
    accountGroupId: number;
    accountGroupName: string,
    accountId: number;
    accountName: string;
    trackerId: string;
    campaignId: number;
    roleAuthorization: number;
    customSegment: number;
    geoSegment: number;
  };
  userprofile: {
    userId: number;
    userName: string;
    mailAddress: string;
    systemAdmin: number;
    sideMenuControl: number;
  };
  authorization: Array<{
    accountGroup: number;
    roleName: string;
    roleId: number;
    roleAuthorization: number;
  }>,
  accesstoken: string;
  isUseForDisplayAdsOnly: boolean;

  // フィルターの状態を格納する為のオブジェクト
  filterInfo: {
    displayParentArchiveFilterValue: number[];
  }
}

type Action = {
  type: string;
  payload: State;
}

// 初期クリアデータ
const initialState: State = {
  title: 'Apollo Apli',
  apolloList: [
    {
      accountGroup: {id: 0, name: "", roleAuthorization: 0, customSegment: 1, geoSegment: 1},
      accountList: [
        {id: 0, name: "", trackerId: ""},
      ]
    },
  ],
  current: {
    accountGroupId: 0,
    accountGroupName: "",
    accountId: 0,
    accountName: "",
    trackerId: "",
    campaignId: 0,
    roleAuthorization: 0,
    customSegment: 1,
    geoSegment: 1,
  },
  userprofile: {
    userId: 0,
    userName: "",
    mailAddress: "",
    systemAdmin: 0,
    sideMenuControl: 0,
  },
  authorization: [{accountGroup: 0, roleId: 0, roleName: "", roleAuthorization: 0}],
  accesstoken: "",
  isUseForDisplayAdsOnly: false,
  filterInfo: {
    displayParentArchiveFilterValue: [1],
  }
};

export const ApolloContext = createContext({} as {
  state: State
  dispatch: React.Dispatch<Action>
});

export let KEY_CONTEXT_TOKEN = "APOLLOCONTEXT"

const reducer = (state: State, action: Action) => {
  let cdata = state;
  switch (action.type) {
    case 'changeAccount':
      cdata.current = action.payload.current
      break;
    case 'setAccount':
      cdata.current = action.payload.current
      cdata.userprofile = action.payload.userprofile
      cdata.authorization = action.payload.authorization
      cdata.apolloList = action.payload.apolloList
      cdata.accesstoken = action.payload.accesstoken
      break;
    case 'setApolloList':
      cdata.apolloList = action.payload.apolloList
      cdata.current = action.payload.current
      break;
    case 'setAccessToken':
      cdata.accesstoken = action.payload.accesstoken
      break;
    case 'setTrackerId':
      cdata.apolloList = action.payload.apolloList
      cdata.current.trackerId = action.payload.current.trackerId
      break;
    case 'clearAccount':
      cdata = initialState;
      break;
    case 'changeIsUseForDisplayAdsOnly':
      cdata.isUseForDisplayAdsOnly = action.payload.isUseForDisplayAdsOnly
    case 'changeFilterInfo':
      cdata.filterInfo = action.payload.filterInfo
      break;
    default:
      break;
  }
  sessionStorage.setItem(KEY_CONTEXT_TOKEN, JSON.stringify(cdata));
  return cdata;
};

const ApolloContextProvider: React.FC = ({...props}) => {

  const initdata = sessionStorage.getItem(KEY_CONTEXT_TOKEN)
  const [state, dispatch] = React.useReducer(reducer, initdata ? JSON.parse(initdata) : initialState);
  return (
    <ApolloContext.Provider
      value={{
        state,
        dispatch
      }}
    >
      {props.children}
    </ApolloContext.Provider>
  );
};


export default ApolloContextProvider;
